import React, { useState, useContext } from "react";
import { Form, Input, Button } from "antd";
import { useLocalStorage } from "../hooks";
import { UserContext } from "../context/UserContext";
import { changePassword } from "../utils/api";
import LoadingIcon from "./LoadingIcon";

const PasswordModalContent = ({ setOpen }) => {
  const { userData } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);

  const onFinish = async (values) => {
    console.log("Success:", values);
    setIsLoading(true);
    const res = await changePassword(values);
    setIsLoading(false);
    setOpen(false);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div className="flex justify-center ">
      {!isLoading ? (
        <Form
          id="myForm"
          layout="vertical"
          className="w-[300px]"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            className="mr-2"
            name="current_password"
            label="Current Password"
            rules={[
              {
                type: "password",
                required: true,
                message: "Please input your password!",
              },
            ]}
          >
            <Input placeholder="Current Password" />
          </Form.Item>
          <Form.Item
            className="mr-2"
            name="new_password"
            label="New Password"
            rules={[
              {
                type: "password",
                required: true,
                message: "Please input your password!",
              },
              {
                min: 8,
                message: "Password must have a minimum length of 8",
              },
              {
                pattern: new RegExp(
                  "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$",
                ),
                message:
                  "Password must contain at least one lowercase letter, uppercase letter, number, and special character",
              },
            ]}
          >
            <Input placeholder="New Password" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      ) : (
        <LoadingIcon height="300px" classname="absolute h-full" />
      )}
    </div>
  );
};

export default PasswordModalContent;
